/**
 * Removes elements defined by an index and an element count from an array and returns a new array.
 *
 * @returns a new array with the requested elements removed
 */
export function removeElements(array, index, count) {
    if (index < 0)
        return [...array];
    return array.filter((_v, i) => i < index || i >= index + count);
}
